import LoadingEmptyError from "components/LoaderEmptyErrorState";
import withLoader from "hoc/loader";
import React from "react";

import { ShoppingWidgetProps } from "./interface";
import ShoppingCardItem from "./ShoppingCard";
import { GridWrapper } from "./styled.components";

const Shopping = ({ items, isError, isFetching }: ShoppingWidgetProps) => {
  const isEmpty = !items || items.length === 0;

  if (isError || isFetching || isEmpty) {
    return (
      <LoadingEmptyError
        isEmpty={isEmpty}
        isError={isError}
        isLoading={isFetching}
        largesize={true}
      />
    );
  }

  return (
    <GridWrapper>
      {items.map((item) => (
        <ShoppingCardItem key={item.id} item={item} />
      ))}
    </GridWrapper>
  );
};

const PURE = React.memo(withLoader(Shopping));
export default PURE;
